import { useIntl } from 'react-intl';

import { EM_DASH } from '~/common/constants/unicode';
import { Box } from '~/eds/src/components/Box/Box';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';

import { getSingleFieldValue } from '../../helpers';
import { BaseFieldProps } from './fieldTypes';

export const StringField = ({
  field,
  editMode,
  editData,
  onEditDataChange,
  isWssField,
}: BaseFieldProps) => {
  const intl = useIntl();
  const presentValue = editData[field.id];

  if (editMode) {
    const stringValue =
      typeof presentValue === 'string' || typeof presentValue === 'number'
        ? String(presentValue)
        : '';

    return (
      <Box flex="1">
        <TextInput
          name={field.name}
          aria-label={field.name}
          value={stringValue}
          onChange={(updatedValue: string | null) =>
            onEditDataChange(field.id, updatedValue)
          }
          disabled={!field.is_editable || isWssField(field)}
          placeholder={intl.formatMessage(
            {
              id: 'StringField.enterFieldName',
              defaultMessage: 'Enter {fieldName}',
              description:
                'Placeholder text for string input field. Example: fieldName = "Contract Type"',
            },
            { fieldName: field.name },
          )}
        />
      </Box>
    );
  }

  const singleValue = getSingleFieldValue(field.value);
  return singleValue ? singleValue.display_value : EM_DASH;
};
